export const menuWidth = {
  minWidth: '200px',
};
